import { useCallback, useMemo } from "react";

import { Dropdown, DropdownProps } from "./form/dropdown";
import { useProfile } from "../profile/profile";
import { useTenantConfig } from "../tenant-settings";
import { useAuthContext } from "~/auth/auth-store";

enum Settings {
  PROFILE = "PROFILE",
  TUTORIAL = "TUTORIAL",
  SIGN_OUT = "SIGN_OUT",
}

export const SettingsDropdown: React.FC<{
  isMobileView?: boolean;
}> = ({ isMobileView }) => {
  const { showProfile } = useProfile();
  const { signOut } = useAuthContext();

  const { hideTutorial } = useTenantConfig();

  const options: DropdownProps<Settings>["options"] = useMemo(
    () =>
      hideTutorial
        ? [
            {
              value: Settings.PROFILE,
              label: { tx: "profile.headerTitle" },
            },

            {
              value: Settings.SIGN_OUT,
              label: { tx: "auth.signOut.signOutButton" },
            },
          ]
        : [
            {
              value: Settings.PROFILE,
              label: { tx: "profile.headerTitle" },
            },
            {
              value: Settings.TUTORIAL,
              label: { tx: "profile.tutorial" },
            },
            {
              value: Settings.SIGN_OUT,
              label: { tx: "auth.signOut.signOutButton" },
            },
          ],
    [hideTutorial],
  );

  const optionsActionMap: Partial<Record<Settings, () => void>> = useMemo(
    () =>
      hideTutorial
        ? {
            [Settings.PROFILE]: showProfile,
            [Settings.SIGN_OUT]: signOut ?? (() => {}),
          }
        : {
            [Settings.PROFILE]: showProfile,
            [Settings.SIGN_OUT]: signOut ?? (() => {}),
          },
    [hideTutorial, showProfile, signOut],
  );

  const onChangeDropdownValue = useCallback(
    (value: Partial<Settings>) => {
      optionsActionMap[value]?.();
    },
    [optionsActionMap],
  );

  return (
    <Dropdown
      noValueSelected={{ tx: "general.settings" }}
      options={options}
      onChange={onChangeDropdownValue}
      className={isMobileView ? "dropdown-top" : undefined}
    />
  );
};
